/*
 * Disaster Tees — autoplaying TikTok clip.
 *
 * Plays muted only while the frame is on screen (no battery burn scrolling
 * past), never autoplays for people who ask for reduced motion, and exposes a
 * single Sound toggle. Without JavaScript the poster frame shows and the whole
 * card still links to TikTok.
 */
class DTAutoplayVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;

    this.sound = this.querySelector('[data-dt-sound]');
    this.video.muted = true;
    this.sound?.addEventListener('click', this.#toggleSound);

    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) this.video.play().catch(() => {});
        else this.video.pause();
      },
      { threshold: 0.35 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.sound?.removeEventListener('click', this.#toggleSound);
  }

  #toggleSound = () => {
    this.video.muted = !this.video.muted;
    if (!this.video.muted && this.video.paused) this.video.play().catch(() => {});
    this.sound.setAttribute('aria-pressed', String(!this.video.muted));
  };
}

if (!customElements.get('dt-autoplay-video')) customElements.define('dt-autoplay-video', DTAutoplayVideo);
